export default __webpack_public_path__ + "static/media/Icon-1.e42e8f66.gif";